import { PureComponent } from 'react'
import PropTypes from 'meta/PropTypes'
import { Box, Flex, Layout } from 'react-flex-lite'
import cn from 'classnames'
import { Title, Paragraph } from 'components/display/Text'
import './index.scss'

const FlexA = Layout((props) => <a {...props} />)

const posts = [
  {
    id: 'whose-lane-is-it',
    title: 'Whose lane is it?',
    subtitle: 'Process snapshot of a community data project on blocked bike lanes in New York City.',
    url: 'https://medium.com/city-as-a-service/whose-lane-is-it-fb9e86affdec',
    image: 'https://miro.medium.com/max/600/1*wUqlNLUYtpGIZp944v84vQ.png'
  },
  {
    id: 'city-as-a-service',
    title: 'City as a Service',
    subtitle: 'What do you get when you mix open data from restaurant inspections, recycling capture rates, and blocked bike lanes?',
    url: 'https://medium.com/city-as-a-service/the-open-city-e1ac63ffafc5',
    image: 'https://miro.medium.com/max/600/1*fZgP4o9TXu7PqAUw92izjw.jpeg'
  }
]

@Layout
export default class BlogPosts extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  }
  render = () => {
    const { className, ...rest } = this.props
    if (!posts || posts.length === 0) return null
    return <Flex wrap className={cn('blog-posts-component', className)} {...rest}>
      {posts.map((post) =>
        <FlexA column className="post" href={post.url} key={post.id}>
          <Box className="post-img" style={{ backgroundImage: `url(${post.image})` }} />
          <Title mt={3} mb={1} className="post-title">{post.title}</Title>
          <Paragraph>{post.subtitle}</Paragraph>
        </FlexA>
      )}
    </Flex>
  }
}
